export default (updatedCertificateNumber) => ({
    type: "CERTIFICATE_NUMBER_UPDATED",
    data: updatedCertificateNumber
});